// Add your custom JS here.

(function ($) {

	$(document).ready(function () {
		setCookieFesteBanner();
		setCookiNoPurchasesBanner();
		//setNumberCart();

		/* cart */
		moveFooterOnEmptyCart();
		setCartCounterPosition();

		/* Woocommerce gallery */
		woocommerceGalleryImageCleaner();
		setCheckboxMailchimp();

		//$(window).scrollTop(0);

	});

	$(window).resize(function () {
		/* cart */
		setCartCounterPosition();

	});

	/*SET NUMBER CART DESKTOP*/
	function setNumberCart() {
		$(".cart-menu-item").html("<div id='mini-cart-count'></div>");
	}


	/* Cart */
	function moveFooterOnEmptyCart() {
		var emptyInput = $(".cart-empty").length;
		if (emptyInput > 0) {
			$("#wrapper-footer").addClass("cart-is-empty");
		}
	}

	function setCartCounterPosition() {

		setTimeout(function () {
			var w = $(".login-menu-item").width();
			var w_mobile = $(".cart-menu-item-mobile").width();
			var resolution = $(window).width();
			var w_mobile_app = w_mobile;
			if (resolution > 767) {
				w = w + 40;
				//$("#mini-cart-count-desktop").css("right",w);
				$("#mini-cart-count-desktop").css("display", "block");
			}
			else if (resolution <= 767) {
				w_mobile = 2;
				//w_mobile_app = w_mobile - 5;
				if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
					$("#mini-cart-count-mobile").css("right", w_mobile);
					$("#mini-cart-count-mobile").css("top", "0px");
					$("#mini-cart-count-mobile").css("line-height", "13px");

					if ($("#mini-cart-count-mobile").text == "0") {
						$("#mini-cart-count-mobile").css("pointer-events", "none");
					}
				}
				else {
					$("#mini-cart-count-mobile").css("right", w_mobile);
					$("#mini-cart-count-mobile").css("top", "0px");
					$("#mini-cart-count-mobile").css("line-height", "13px");
				}
				$("#mini-cart-count-mobile").css("display", "block");
			}
		}, 1600);

	}

	function woocommerceGalleryImageCleaner() {

		var selector = $("#woocommerce-wrapper .woocommerce-product-gallery ol li img");
		var newsrc;
		var src;

		$(selector).each(function () {
			src = $(this).attr("src");
			newsrc = src.replace('-100x100', '');
			$(this).attr("src", newsrc);
		});

	}

	function setCookieFesteBanner() {
		let acceptCookie = document.getElementById("acceptCookie");
		if (acceptCookie) {

			var cookieName = "FesteSGPBanner";
			var cookieValue = "Avviso spedizione corrieri SGP";
			var cookieExpireDays = 30;
			// when users click accept button
			//let acceptCookie= document.getElementById("acceptCookie");
			acceptCookie.onclick = function () {
				createCookie(cookieName, cookieValue, cookieExpireDays);
			}
			// function to set cookie in web browser
			let createCookie = function (cookieName, cookieValue, cookieExpireDays) {
				let currentDate = new Date();
				currentDate.setTime(currentDate.getTime() + (cookieExpireDays * 24 * 60 * 60 * 1000));
				//let expires = "expires=" + currentDate.toGMTString();
				//document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/"; //cookie persistente
				document.cookie = cookieName + "=" + cookieValue + ";" + ";path=/"; // cookie di sessione
				if (document.cookie) {
					document.getElementById("cookiePopup").style.display = "none";
				} else {
					alert("Unable to set cookie. Please allow all cookies site from cookie setting of your browser");
				}
			}
			// get cookie from the web browser
			let getCookie = function (cookieName) {
				let name = cookieName + "=";
				let decodedCookie = decodeURIComponent(document.cookie);
				let ca = decodedCookie.split(';');
				for (let i = 0; i < ca.length; i++) {
					let c = ca[i];
					while (c.charAt(0) == ' ') {
						c = c.substring(1);
					}
					if (c.indexOf(name) == 0) {
						return c.substring(name.length, c.length);
					}
				}
				return "";
			}
			// check cookie is set or not
			let checkCookie = function () {
				let check = getCookie(cookieName);
				if (check == "") {
					document.getElementById("cookiePopup").style.display = "block";
				} else {

					document.getElementById("cookiePopup").style.display = "none";
				}
			}
			checkCookie();


		}

	}


	function setCookiNoPurchasesBanner() {
		let acceptCookie = document.getElementById("acceptCookie");
		var check_pagine_banner = ["sgp-shop", "prodotto", "cart", "checkout"];
		if (acceptCookie) {
			for (var i = 0; i < check_pagine_banner.length; i++) {
				if (window.location.href.indexOf(check_pagine_banner[i]) > -1) {
					var cookieName = "FesteSGPBanner";
					var cookieValue = "Avviso spedizione corrieri SGP";
					var cookieExpireDays = 30;
					// when users click accept button
					//let acceptCookie= document.getElementById("acceptCookie");
					acceptCookie.onclick = function () {
						createCookie(cookieName, cookieValue, cookieExpireDays);
					}
					// function to set cookie in web browser
					let createCookie = function (cookieName, cookieValue, cookieExpireDays) {
						let currentDate = new Date();
						currentDate.setTime(currentDate.getTime() + (cookieExpireDays * 24 * 60 * 60 * 1000));
						//let expires = "expires=" + currentDate.toGMTString();
						//document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/"; //cookie persistente
						document.cookie = cookieName + "=" + cookieValue + ";" + ";path=/"; // cookie di sessione
						if (document.cookie) {
							document.getElementById("cookiePopup").style.display = "none";
						} else {
							alert("Unable to set cookie. Please allow all cookies site from cookie setting of your browser");
						}
					}
					// get cookie from the web browser
					let getCookie = function (cookieName) {
						let name = cookieName + "=";
						let decodedCookie = decodeURIComponent(document.cookie);
						let ca = decodedCookie.split(';');
						for (let i = 0; i < ca.length; i++) {
							let c = ca[i];
							while (c.charAt(0) == ' ') {
								c = c.substring(1);
							}
							if (c.indexOf(name) == 0) {
								return c.substring(name.length, c.length);
							}
						}
						return "";
					}
					// check cookie is set or not
					let checkCookie = function () {
						let check = getCookie(cookieName);
						if (check == "") {
							document.getElementById("cookiePopup").style.display = "block";
						} else {

							document.getElementById("cookiePopup").style.display = "none";
						}
					}
					checkCookie();
				}
			}
		}

	}

	function setCheckboxMailchimp() {
		$("#mailchimp_woocommerce_newsletter").click(function () {
			var checked = jQuery("#mailchimp-gdpr-fields .input-checkbox").is(':checked');
			if (checked) {
				$('#mailchimp-gdpr-fields .input-checkbox').prop('checked', false);
			} else {
				$('#mailchimp-gdpr-fields .input-checkbox').prop('checked', true);
			}
		});
	}

})(jQuery);








